export default __webpack_public_path__ + "static/media/ecom.32eec44d.PNG";